import React from "react";
import PropTypes from "prop-types";
import { ICON_MAP } from "../../Assets/icons/icons";

const Icon = ({ name, layoutClass }) => {
  const IconToRender = ICON_MAP[name];
  return <IconToRender className={layoutClass} />;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  layoutClass: PropTypes.string,
};

Icon.defaultProps = {
  layoutClass: "",
};

export default Icon;
